<template>
    <div class="hero">
        <prismic-image :field="slice.primary.hero_image" class="hero--image"/>
        <div class="hero--overlay"/>
        <div class="hero--content">
            <div class="container">
                <h1 class="hero--title">{{$prismic.richTextAsPlain(slice.primary.hero_title) }}</h1>
                <prismic-rich-text :field="slice.primary.hero_description" class="hero--description"/>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props : ['slice'],
        name : "hero"
    }
</script>
<style lang="scss">
.hero {
    position: relative;
    width: 100vw;
    height: 50vh;
    overflow: hidden;
    &--image {
        width: 100%;
    }
    &--overlay {
        background: rgba(0, 0, 0, 0.6);
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        @media (max-width: 767px) {
            background: #02273e;
        }
    }
    &--content {
        position: absolute;
        top: 20vh;
        width: 100%;
        left: 0;
        display: block;
        @media (max-width: 767px) {
            top: 12vh;;
        }
    }
    &--title,
    &--description * {
        color: #fff;
    }
}
.home-slices .hero {
    height: 80vh;
    @media (max-width: 767px) {
        height: auto;
    }
    &--content {
        top: 50vh;
        @media (max-width: 767px) {
            position: relative;
            top: 0;
        }
    }
    &--overlay {
        @media (max-width: 767px) {
            display: none;
        }
    }
    &--title,
    &--description * {
        @media (max-width: 767px) {
            color: #555;
        }
    }

}
</style>


